export default __webpack_public_path__ + "static/media/success.7821fa7d.svg";